import styled from 'styled-components';

export const PageContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const PageWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;

export const PageContent = styled.div`
  width: 100%;
  position: relative;
  top: -25px;
`;
